<span *ngIf="shouldShowAll">
    <span [innerHTML]="text"></span>
    <span (mousedown)="showAll(false, $event)" class="see-more" *ngIf="shouldShowSeeLess"> See less</span>
</span>
<span *ngIf="!shouldShowAll">
    <span [innerHTML]="getShortenText()"></span>
    <span (mousedown)="showAll(true, $event)" class="see-more">... See more</span>
</span>
